const requestOptions = (formData) => {
    return {
        method: 'POST',
        body: formData,
    };
};

export default requestOptions;
